// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import MaintenanceService from '../../services/MaintenanceService';
import PersonnelService from '../../services/PersonnelService';

const OffcanvasAddMaintenanceForm = ({ onClick }) => {
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [PersonnelOptions, setPersonnelOptions] = useState([]);

	const STATUT_CHOICES = [
		{ value: 'en_attente', label: 'En Attente' },
		{ value: 'en_cours', label: 'En Cours' },
		{ value: 'terminee', label: 'Terminee' }
	];
	const URGENCE_CHOICES = [
		{ value: 'faible', label: 'Faible' },
		{ value: 'moderee', label: 'Moderee' },
		{ value: 'elevee', label: 'Elevee' }
	];

	useEffect(() => {
		const fetchPersonnelOptions = async () => {
			try {
				const Personnels = await PersonnelService.getPersonnelOptions();
				setPersonnelOptions(Personnels);
			} catch (error) {
				console.error('Error fetching class options', error);
			}
		};

		fetchPersonnelOptions();
	}, []);

	const Personnel_CHOICES = PersonnelOptions;

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const MaintenanceData = new FormData();

				// Add all your form data to the FormData
				MaintenanceData.append('type_service', form.type_service.value);
				MaintenanceData.append(
					'description_probleme',
					form.description_probleme.value
				);
				MaintenanceData.append('urgence', form.urgence.value);
				MaintenanceData.append('personnel', form.personnel.value);
				MaintenanceData.append('date_demande', form.date_demande.value);
				MaintenanceData.append('contact', form.contact.value);
				MaintenanceData.append('statut', form.statut.value);

				// Call the MaintenanceService to create the Maintenance
				const response = await MaintenanceService.createMaintenance(
					MaintenanceData
				);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of Maintenances
				window.location.href = '/services/maintenance';
			} catch (error) {
				console.error(
					'Erreur lors de la création de la demande de maintenance',
					error
				);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				<Col xs={12} className="mb-3">
					{/* type_service et description_probleme  */}
					<Form.Group>
						<Form.Label htmlFor="type_service">
							Type de service <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="type_service"
							type="text"
							placeholder="Saisir le Type de service de Maintenance"
							id="type_service"
							required
							isInvalid={!!feedbackMessages['type_service']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									type_service: e.target.value
										? ''
										: 'Le Type de service est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['type_service']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col xs={12} className="mb-3">
					{/* type_service et description_probleme  */}
					<Form.Group>
						<Form.Label htmlFor="description_probleme">
							Description du probleme <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="description_probleme"
							as="textarea"
							placeholder="Saisir la Description du probleme de la Maintenance"
							id="description_probleme"
							required
							isInvalid={!!feedbackMessages['description_probleme']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									description_probleme: e.target.value
										? ''
										: 'La Description du probleme est requis.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['description_probleme']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
				<Col xs={12} className="mb-3">
					{/* contact  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="contact">Contact</Form.Label>
								<Form.Control
									name="contact"
									type="number"
									placeholder="Saisir le contact "
									id="contact"
									required
									isInvalid={!!feedbackMessages['contact']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											contact: e.target.value ? '' : 'Le contact est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['contact']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>

				{/* urgence */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="urgence">
							Urgence <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="urgence"
							required
							isInvalid={!!feedbackMessages['urgence']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									urgence: e.target.value
										? ''
										: "L'urgence de la Maintenance est requis."
								}));
							}}
						>
							{URGENCE_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['urgence']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* personnel */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="personnel">
							Personnel <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="personnel"
							required
							isInvalid={!!feedbackMessages['personnel']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									personnel: e.target.value
										? ''
										: 'Le personnel de Maintenance est requis.'
								}));
							}}
						>
							{Personnel_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['personnel']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>
				{/* date_demande */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="date">
							Date de demande <span className="text-danger">*</span>
						</Form.Label>
						<Form.Control
							name="date_demande"
							type="date"
							placeholder="Saisir une Date de demande"
							id="date"
							required
							isInvalid={!!feedbackMessages['date']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									date: e.target.value ? '' : 'La Date de demande est requise.'
								}));
							}}
						/>
						<Form.Control.Feedback type="invalid">
							{feedbackMessages['date_demande']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* statut */}
				<Col xs={12} className="mb-3">
					<Form.Group className="mb-3">
						<Form.Label htmlFor="statut">
							statut <span className="text-danger">*</span>
						</Form.Label>
						<Form.Select
							name="statut"
							required
							isInvalid={!!feedbackMessages['statut']}
							onChange={(e) => {
								setFeedbackMessages((prevMessages) => ({
									...prevMessages,
									statut: e.target.value
										? ''
										: 'Le statut de la Maintenance est requis.'
								}));
							}}
						>
							{STATUT_CHOICES.map((option, index) => (
								<option key={index} value={option.value}>
									{option.label}
								</option>
							))}
						</Form.Select>
						<Form.Control.Feedback statut="invalid">
							{feedbackMessages['statut']}
						</Form.Control.Feedback>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddMaintenanceForm;
